import React from "react";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ReceiptIcon from "@mui/icons-material/Receipt";
import BarChartIcon from "@mui/icons-material/BarChart";
import AddBoxIcon from "@mui/icons-material/AddBox";
import PaymentIcon from "@mui/icons-material/Payment";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { NavLink } from "react-router";

// Inspired by modern, card-style minimal UIs
function DismissableBanner() {
  const actions = [
    {
      title: "Register Cashier",
      icon: <PersonAddIcon fontSize="medium" />,
      link: "/admin/users",
      color: "bg-gradient-to-tr from-blue-500 to-blue-400",
    },
    {
      title: "Generate Invoice",
      icon: <ReceiptIcon fontSize="medium" />,
      link: "/admin/invoice",
      color: "bg-gradient-to-tr from-pink-500 to-pink-400",
    },
    {
      title: "Check Sales",
      icon: <BarChartIcon fontSize="medium" />,
      link: "/admin/sales",
      color: "bg-gradient-to-tr from-green-500 to-green-400",
    },
    {
      title: "New Product",
      icon: <AddBoxIcon fontSize="medium" />,
      link: "/admin/addproduct",
      color: "bg-gradient-to-tr from-yellow-500 to-yellow-400",
    },
    {
      title: "Add Expense",
      icon: <PaymentIcon fontSize="medium" />,
      link: "/admin/expenses",
      color: "bg-gradient-to-tr from-purple-500 to-purple-400",
    },
    {
      title: "Add Customer",
      icon: <GroupAddIcon fontSize="medium" />,
      link: "/admin/customers",
      color: "bg-gradient-to-tr from-cyan-500 to-cyan-400",
    },
  ];

  return (
    <div className="mb-6 bg-white p-4 md:p-6 rounded-xl shadow-sm border">
      <h2 className="text-xl font-semibold mb-3 text-neutral-800">Quick Actions</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
        {actions.map((action, index) => (
          <NavLink
            key={index}
            to={action.link}
            className="focus:outline-none"
            tabIndex={0}
            onClick={() => {
              localStorage.setItem("action", "add");
            }}
          >
            <div
              className={`
                flex flex-col items-center justify-center px-2 py-3 rounded-lg shadow-none 
                border border-transparent bg-white 
                hover:shadow-lg hover:border-blue-100 group transition-all duration-150
                active:scale-[0.97]
                cursor-pointer
              `}
              style={{ minHeight: "92px" }}
            >
              <div
                className={`
                  ${action.color} flex items-center justify-center 
                  rounded-full w-10 h-10 sm:w-11 sm:h-11 mb-2 transition-all
                  group-hover:shadow-lg group-hover:scale-110
                  text-white
                `}
              >
                {action.icon}
              </div>
              <span className="text-gray-700 text-xs text-center font-medium leading-tight tracking-tight">
                {action.title}
              </span>
            </div>
          </NavLink>
        ))}
      </div>
    </div>
  );
}

export default DismissableBanner;